import React from "react";

export const EntryConfirmView = (props) => {
    

    return (
        <>
        <div className="select_desc al-c">
			入力内容をご確認ください
		</div>
		
            <table className="table_confirm">
                <tbody>
                <tr>
                    <th>お名前</th>
                    <td>{props.fromValue.name}</td>
                </tr>
                <tr>
                    <th>住所</th>
                    <td>{props.fromValue.address}</td>
                </tr>
                <tr>
                    <th>メールアドレス</th>
                    <td>{props.fromValue.email}</td>
                </tr>
                <tr>
                    <th>性別</th>
                    <td>{props.fromValue.sex}</td>
                </tr>
                <tr>
                    <th>年齢</th>
                    <td>{props.fromValue.age}</td>
                </tr>
                <tr>
                    <th>ご家族の人数</th>
                    <td>{props.fromValue.family}</td>
                </tr>
                <tr>
                    <th>応募コース</th>
                    <td>{props.InputEntry.cource}</td>
                </tr>
                { props.InputEntry.products !== null &&
                    <tr>
                        <th>購入商品</th>
                        <td>{props.InputEntry.products.map(p => `${p}\n`)}</td>
                    </tr>
                }
                <tr>
                    <th>購入店</th>
                    <td>{props.InputEntry.store}</td>
                </tr>
                { props.InputEntry.presents !== null &&
                <tr>
                    <th>応募商品</th>
                    <td>{props.InputEntry.presents.map(p => `${p}\n`)}</td>
                </tr>
                }
                </tbody>
            </table>

			<div className="block5 w-500 mt-40">
				<div className="block5_1">
                    <button 
                        className="btn8" 
                        onClick={props.onSend}>応募を確定する</button>
                </div>
				<div className="block5_2">
                    <a className="btn6"  
                    onClick={props.offConfirm}>戻る</a></div>
			</div>
        </>
    )
}